import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { PersonProfileEditHintBlock } from '../../_blocks/PersonProfileEditHint/PersonProfileEditHintBlock';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { isEmptyBlock } from '../../types/api/Block';

export type PersonProfileEditHintWidget = WidgetShape<[PersonProfileEditHintBlock], WidgetType.personprofileedithint>;

export function PersonProfileEditHintWidget({ blocks, elementType, ...headerProps }: PersonProfileEditHintWidget) {
  const { t } = useSonTranslation('PersonProfileEditHint');

  if (isEmptyBlock(blocks[0])) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader {...headerProps} widgetType={elementType} icon={Icons.INFO_BOX} title={t('widgetTitle')}>
      <PersonProfileEditHintBlock {...blocks[0]} />
    </DefaultWidgetWithHeader>
  );
}
